import React from "react";

import { InputProps } from "../../utils/types/props.input";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  InputGroup,
  InputLeftElement,
  Text,
  FormHelperText,
} from "@chakra-ui/react";
import { color } from "../../utils/theme";
interface ExtendedInputProps
  extends Omit<
    InputProps,
    "type" | "placeholder" | "ref" | "onChange" | "value"
  > {
  children: React.ReactElement;
}

const FormInputWrapper = ({
  label,
  isRequired,
  icon,
  children,
  helperText,
  errorMessage,
  margin,
}: ExtendedInputProps) => {
  return (
    <FormControl  isInvalid={errorMessage ? true : false} margin={margin}>
      <FormLabel color={color.text} display={'flex'} mb={0} fontSize={16}>
        {label} {isRequired && <Text color={"red"} mx={1} fontSize={24}>*</Text>}
      </FormLabel>
      <InputGroup>
        {icon && (
          <InputLeftElement pointerEvents="none">{icon}</InputLeftElement>
        )}
        {children}
      </InputGroup>
      {errorMessage ? (
        <FormErrorMessage marginY={3} fontWeight={"normal"}>
          {errorMessage}
        </FormErrorMessage>
      ) : (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FormInputWrapper;
